import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../account/auth.service';

@Component({
  selector: 'app-aside',
  templateUrl: './app-aside.component.html'
})
export class AppAsideComponent {

  constructor(private authService: AuthService,
              private router: Router) { }

  logout() {
    this.authService.logout();
    
  }
  changePassword() {
    this.router.navigate(['/changepassword']);
  }
  isLoggedIn() : boolean {
    return this.authService.isLoggedIn();
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/components/app-aside/app-aside.component.ts